import { useSelector, useDispatch } from 'react-redux';

import { useIntl } from 'src/hooks/intl';
import { changeFilterState } from 'src/redux/jira/actions';
import { IssueCategory } from 'src/redux/jira/constants';
import { FilterState } from 'src/redux/jira/types';
import { BucketState } from 'src/types/state';

import { MultiSelectFilterDropdown } from '../filter-dropdown';

import messages from './issue-category-filter.i18n';

export const IssueCategoryFilter = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const filterState = useSelector<BucketState, FilterState>(
    state => state.jira.jiraRepoPage.filterState
  );

  const handleChange = (issueCategories: string[]) => {
    dispatch(
      changeFilterState({ issueCategories: issueCategories as IssueCategory[] })
    );
  };

  const options = [
    {
      label: intl.formatMessage(messages.todoFilterOption),
      value: IssueCategory.Todo,
    },
    {
      label: intl.formatMessage(messages.inProgressFilterOption),
      value: IssueCategory.InProgress,
    },
    {
      label: intl.formatMessage(messages.doneFilterOption),
      value: IssueCategory.Done,
    },
  ];

  const selected = options
    .filter(option =>
      (filterState.issueCategories || []).some(id => id === option.value)
    )
    .map(option => option.value);

  return (
    <MultiSelectFilterDropdown
      isLoading={false}
      label={intl.formatMessage(messages.issueCategoryFilterDropdownLabel)}
      onChange={handleChange}
      options={options}
      optionsTitle={intl.formatMessage(messages.issueCategoryFilterGroupHeader)}
      tooltipText={intl.formatMessage(messages.issueCategoryFilterTooltipText)}
      selected={selected}
    />
  );
};
